import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight, Sparkles } from 'lucide-react';

/**
 * Global top announcement bar — sits above SiteHeader on every page.
 * Promotes the new Noida Experience Centre.
 */
const AnnouncementBar = () => {
  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-gradient-to-r from-orange-600 via-orange-500 to-amber-500 text-white text-[12px] md:text-[13px] font-semibold"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6 py-2 flex flex-col md:flex-row items-center justify-center gap-1.5 md:gap-4 text-center">
        <span className="inline-flex items-center gap-1.5">
          <Sparkles className="w-3.5 h-3.5 text-yellow-200 animate-pulse" />
          <span className="uppercase tracking-wide">NEW · Noida Experience Centre Now Open</span>
        </span>
        <span className="hidden md:inline text-white/60">|</span>
        <span className="inline-flex items-center gap-1.5 opacity-95">
          <MapPin className="w-3.5 h-3.5" />
          404, Tower A – Ithum Building, Sector 62, Noida
        </span>
        <span className="hidden md:inline text-white/60">|</span>
        <Link
          to="/noida"
          data-testid="announcement-book-visit"
          className="inline-flex items-center gap-1.5 bg-white text-orange-700 hover:bg-orange-50 rounded-full px-3 py-1 font-bold shadow-sm transition-all"
        >
          Book Your Visit <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    </div>
  );
};

export default AnnouncementBar;
